.container {
  max-width: 640px;
  margin: 0 auto;
  padding: 20px 40px;
  font-size: 14px;
}
